module.exports = __webpack_public_path__ + "static/logo-transparent-33fe92cc19048eff8129071c31957eca.svg";